import { useState, useRef, useEffect } from 'react';
import './Select.css';

function Select({
    value,
    onChange,
    options,          // [{ value, label }]
    placeholder = '— Выберите —',
    disabled = false,
    loading = false,
}) {
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);

    // Закрытие по клику вне компонента
    useEffect(() => {
        if (!open) return;
        const handleClick = (e) => {
            if (rootRef.current && !rootRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        const handleEsc = (e) => {
            if (e.key === 'Escape') setOpen(false);
        };
        document.addEventListener('mousedown', handleClick);
        document.addEventListener('keydown', handleEsc);
        return () => {
            document.removeEventListener('mousedown', handleClick);
            document.removeEventListener('keydown', handleEsc);
        };
    }, [open]);

    const current = options.find(o => o.value === value);

    const handleSelect = (val) => {
        onChange(val);
        setOpen(false);
    };

    return (
        <div
            ref={rootRef}
            className={
                'custom-select' +
                (open ? ' custom-select--open' : '') +
                (disabled ? ' custom-select--disabled' : '')
            }
        >
            <button
                type="button"
                className="custom-select__control"
                onClick={() => !disabled && setOpen(o => !o)}
                disabled={disabled}
            >
                <span className={current ? '' : 'custom-select__placeholder'}>
                    {loading ? 'Загрузка...' : (current ? current.label : placeholder)}
                </span>
                <span className="custom-select__arrow" />
            </button>

            {open && !disabled && (
                <ul className="custom-select__list" role="listbox">
                    {options.length === 0 && (
                        <li className="custom-select__empty">Нет данных</li>
                    )}
                    {options.map(opt => (
                        <li
                            key={opt.value}
                            role="option"
                            aria-selected={opt.value === value}
                            className={
                                'custom-select__option' +
                                (opt.value === value ? ' custom-select__option--active' : '')
                            }
                            onClick={() => handleSelect(opt.value)}
                        >
                            {opt.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default Select;